exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-ImageButton-___ImageButton__imageButton___3EAM6 {\n  cursor: pointer;\n  width: 40px;\n  height: 30px;\n  background: #e3e8e5;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  border-radius: 2px;\n  overflow: hidden;  \n}\n\n.src-pc-components-molecules-ImageButton-___ImageButton__imageButton___3EAM6 > img {\n  margin: 0;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n}\n", ""]);

// exports
exports.locals = {
	"imageButton": "src-pc-components-molecules-ImageButton-___ImageButton__imageButton___3EAM6"
};